import type { FieldDef } from '../../components/CrudSection';

/** The customer facts that still belong on the customer record. */
export const CUSTOMER_FIELDS: FieldDef[] = [
  { name: 'name', label: 'Name', type: 'text', required: true },
  { name: 'phone', label: 'Phone', type: 'phone', nullable: true },
  { name: 'email', label: 'Email', type: 'text', nullable: true },
  { name: 'notes', label: 'Notes', type: 'text', nullable: true },
  {
    name: 'staffId',
    label: 'One of your own staff',
    type: 'entity',
    resource: 'staff',
    nullable: true,
    description:
      'Link this record to their staff row when the customer works here. Employment status controls the Bar Staff tag and discount; ending employment does not hide the customer.',
  },
  {
    name: 'externalParty',
    label: 'One of the dive shop’s people',
    type: 'select',
    nullable: true,
    options: [
      { value: 'seaHuntStaff', label: 'Dive shop staff' },
      { value: 'seaHuntGuest', label: 'Dive shop guest' },
    ],
    description:
      'Sea Hunt Divers people have no staff row here and no register access. Staff count as employees for discounts; guests do not.',
  },
  {
    name: 'externalRef',
    label: 'Dive shop reference',
    type: 'text',
    nullable: true,
    description: 'How the dive shop’s own records know them.',
  },
  {
    name: 'invoiceName',
    label: 'Name on facturas',
    type: 'text',
    nullable: true,
  },
];

export interface CustomerRecord extends Record<string, unknown> {
  id: string;
  name: string;
  phone: string | null;
  email: string | null;
  notes: string | null;
  invoiceName: string | null;
  status: string;
  linkKind: 'owner' | 'staff' | 'seaHuntStaff' | 'seaHuntGuest' | 'guest';
  hasOwnPrices: boolean;
}
